export default __webpack_public_path__ + "static/media/oa.eff7f7a0.png";